import { createRouter, createWebHistory } from "vue-router";

const routes = [
  //Generic Routes
  {
    path: "/",
    redirect: "/Login",
  },

  {
    path: "/Login",
    name: "Login",
    component: () => import("../views/Auth/Login"),
  },
  {
    path: "/Register",
    name: "Register",
    component: () => import("../views/Auth/Register"),
  },

  {
    path: "/Account/Register",
    name: "Account_Register",
    component: () => import("../views/Auth/ConfirmAccountRegister"),
  },

  {
    path: "/ResetPassword",
    name: "Reset Password",
    component: () => import("../views/Auth/ResetPassword"),
  },

  {
    path: "/Account/ResetPassword",
    name: "Password Reset",
    component: () => import("../views/Auth/changePassword"),
  },

  //companies Routes
  {
    path: "/Dashboard",
    name: "Dashboard",
    component: () => import("../views/Company/Dashboard"),
    isMajor: true,
  },
  {
    path: "/PrimaryRdcVariance",
    name: "Primary-RDC variance report",
    component: () =>
      import("../views/Company/Dashboard/PrimaryVarianceReportRDC.vue"),
    isMajor: true,
  },
  {
    path: "/SecondaryVolumeVariance",
    name: "RDC-secondary volume variance",
    component: () =>
      import("../views/Company/Dashboard/secondaryVolumeVariance.vue"),
    isMajor: true,
  },
  {
    path: "/Primary-tankFills",
    name: "Primary Tank Fills",
    component: () => import("../views/Company/Dashboard/PrimaryTankFills.vue"),
    isMajor: true,
  },
  {
    path: "/truck-sales",
    name: "Truck Sales",
    component: () => import("../views/Company/Reports/TruckSales.vue"),
    isMajor: true,
  },
  {
    path: "/waybills",
    name: "Waybills",
    component: () => import("../views/Company/Reports/Waybills.vue"),
    isMajor: true,
  },
  {
    path: "/TankFills",
    name: "Tank Fills",
    component: () => import("../views/Company/Reports/TanksFilled"),
    isMajor: true,
  },
  {
    path: "/FuelRequests",
    name: "Fuel Requests",
    component: () => import("../views/Company/Reports/FuelRequests"),
    isMajor: true,
  },

  {
    path: "/Primary-reconciliation",
    name: "Primary Reconciliation",
    component: () =>
      import("../views/Company/Reports/PrimaryReconciliaton.vue"),
    isMajor: true,
  },
  {
    path: "/Secondary-reconciliation",
    name: "Secondary Reconciliation",
    component: () => import("../views/Company/Reports/SecondaryReconciliation"),
    isMajor: true,
  },
  {
    path: "/Primary-lifting",
    name: "Primary Lifting",
    component: () => import("../views/Company/Reports/PrimaryLifting"),
    isMajor: true,
  },

  {
    path: "/Secondary-lifting",
    name: "Secondary Lifting",
    component: () => import("../views/Company/Reports/SecondaryLifting"),
    isMajor: true,
  },

  {
    path: "/Deliveries",
    name: "Deliveries",
    component: () => import("../views/Company/Dashboard/Deliveries.vue"),
    isMajor: true,
  },
  {
    path: "/Terminals-Inventory",
    name: "Terminals Inventory",
    component: () => import("../views/Company/Dashboard/TerminalsInventory"),
    isMajor: true,
  },

  {
    path: "/Primary-Trucks",
    name: "Primary Trucks",
    component: () => import("../views/Company/Dashboard/PrimaryTrucks"),
    isMajor: true,
  },
  {
    path: "/Secondary-Trucks",
    name: "Secondary Trucks",
    component: () => import("../views/Company/Dashboard/SecondaryTrucks"),
    isMajor: true,
  },
  {
    path: "/SecondaryPeddlers",
    name: "secondary Peddlers",
    component: () => import("../views/Company/Dashboard/SecondaryPeddlers.vue"),
    isMajor: true,
  },
  {
    path: "/DisconnectedPumps",
    name: "Disconnected Pumps",
    component: () => import("../views/Company/Dashboard/DisconnectedPumps.vue"),
    isMajor: true,
  },
  {
    path: "/Schedules",
    name: "Manage Schedules",
    component: () => import("../views/Company/Dashboard/Schedules.vue"),
    isMajor: true,
  },

  //rdc
  {
    path: "/RedistributionCenters",
    name: "Redistribution Centers",
    component: () =>
      import("../views/Company/Dashboard/RedistributionCenters.vue"),
    isMajor: true,
  },
  {
    path: "/TotalRDCs",
    name: "Total RDCS",
    component: () => import("../views/Company/Dashboard/TotalRDCs.vue"),
  },
  {
    path: "/RDCDetails",
    name: "RdcDetails",
    component: () => import("../views/Company/Dashboard/RDCDetails.vue"),
  },
  {
    path: "/rdc-cluster",
    name: "Rdc Cluster",
    component: () => import("../views/Company/RDC/clusterDetails.vue"),
    isMajor: true,
  },
  {
    path: "/pumpsFaults",
    name: "Pumps Faults",
    component: () => import("../views/Company/RDC/pumpFaults.vue"),
    isMajor: true,
  },
  {
    path: "/StationPumps",
    name: "Pumps in Stations",
    component: () => import("../views/Company/RDC/PumpInStation.vue"),
    isMajor: true,
  },
  {
    path: "/rdcTankReport",
    name: "Rdc Tank Report",
    component: () => import("../views/Company/RDC/filledTank.vue"),
    isMajor: true,
  },
  {
    path: "/tanksFilled",
    name: "Tanks Filled",
    component: () => import("../views/Company/RDC/filledTank.vue"),
    isMajor: true,
  },
  {
    path: "/TankSales",
    name: "Tank Sales",
    component: () => import("../views/Company/RDC/TankSales.vue"),
    isMajor: true,
  },
  {
    path: "/transactions",
    name: "Transactions",
    component: () => import("../views/Company/RDC/transactions.vue"),
    isMajor: true,
  },
  {
    path: "/tanksDetails",
    name: "Tanks Details",
    component: () => import("../views/Company/RDC/tanksDetails.vue"),
    isMajor: true,
  },
  {
    path: "/tankInfo",
    name: "Tanks Info",
    component: () => import("../views/Company/RDC/tankRDCInfo.vue"),
    isMajor: true,
  },
  {
    path: "/manage-orders",
    name: "Manage Orders",
    component: () => import("../views/Company/ManagePeddling/ManageOrders.vue"),
    isMajor: true,
  },
  {
    path: "/manage-thirdparty-orders",
    name: "Manage Thirdparty Orders",
    component: () =>
      import("../views/Company/ManagePeddling/ThirdPartyOrders.vue"),
    isMajor: true,
  },
  {
    path: "/Order-Schedule",
    name: "Order Schedule",
    component: () =>
      import("../views/Company/ManagePeddling/OrderSchedule.vue"),
    isMajor: true,
  },

  {
    path: "/manage-schedules",
    name: "Manage Schedules",
    component: () =>
      import("../views/Company/ManagePeddling/ManageSchedule.vue"),
    isMajor: true,
  },

  //fleets
  {
    path: "/Manage-Trucks",
    name: "Manage trucks",
    component: () => import("../views/Company/Fleet/manageTrucks.vue"),
    isMajor: true,
  },

  {
    path: "/Manage-Voucher",
    name: "Manage Voucher",
    component: () => import("../views/Company/Fleet/Vouchers.vue"),
    isMajor: true,
  },

  {
    path: "/primarySemiTrailers",
    name: "Primary Trucks(Semi-Trailers)",
    component: () => import("../views/Company/Fleet/primarySemiTrailers.vue"),
    isMajor: true,
  },
  {
    path: "/secondaryTrucks",
    name: "Secondary Trucks(Peddlers)",
    component: () => import("../views/Company/Fleet/secondaryPeddlers.vue"),
    isMajor: true,
  },

  //base stations
  {
    path: "/Manage-Depots",
    name: "Manage Depots",
    component: () => import("../views/Company/BaseStations/manageDepots.vue"),
    isMajor: true,
  },

  {
    path: "/CustomerStations",
    name: "Base Stations",
    component: () =>
      import("../views/Company/BaseStations/CustomerBaseStations.vue"),
    isMajor: true,
  },
  {
    path: "/baseUploadHistory",
    name: "BaseStation Upload History",
    component: () =>
      import("../views/Company/BaseStations/BaseStationHistory.vue"),
    isMajor: true,
  },

  {
    path: "/baseUploadHistoryDetails",
    name: "BaseStation Upload History Details",
    component: () =>
      import("../views/Company/BaseStations/BaseStationHistoryDetails.vue"),
    isMajor: true,
  },

  {
    path: "/ProductShipping",
    name: "Product Shipping",
    component: () => import("../views/Company/Shipping/productShipping.vue"),
    isMajor: true,
  },
  //trucks
  {
    path: "/truckDetails",
    name: "Truck Details",
    component: () => import("../views/Company/Trucks/trucksDetails.vue"),
    isMajor: true,
  },
  {
    path: "/tankReport",
    name: "Tank Report",
    component: () => import("../views/Company/Trucks/tankReports.vue"),
    isMajor: true,
  },
  {
    path: "/Meters",
    name: "Meters Faults",
    component: () => import("../views/Company/Trucks/metersFaults.vue"),
  },

  // Manage drivers
  {
    path: "/Manage-Drivers",
    name: "Manage Drivers",
    component: () => import("../views/Company/ManageDrivers/ManageDrivers.vue"),
    isMajor: true,
  },

  {
    path: "/DriverDetails",
    name: "Driver Details",
    component: () => import("../views/Company/ManageDrivers/DriverDetails.vue"),
    isMajor: true,
  },

  {
    path: "/DriverActivities",
    name: "Driver Activities",
    component: () =>
      import("../views/Company/ManageDrivers/DriverActivities.vue"),
    isMajor: true,
  },

  //
  {
    path: "/pumps",
    name: "Pumps",
    component: () => import("../views/Company/Support/pumps.vue"),
    isMajor: true,
  },

  {
    path: "/devices",
    name: "Devices",
    component: () => import("../views/Company/Support/devices.vue"),
    isMajor: true,
  },

  {
    path: "/tanks",
    name: "Tanks",
    component: () => import("../views/Company/Support/tanks.vue"),
    isMajor: true,
  },

  // Messaging

  {
    path: "/messages",
    name: "Messaging",
    component: () => import("../views/Company/Message/index.vue"),
    isMajor: true,
  },

  // Schedule Fulfillment

  {
    path: "/scheduleFulfillment",
    name: "Schedule Fulfillment",
    component: () => import("../views/Company/ScheduleFulfillment/index.vue"),
    isMajor: true,
  },

  // Manage Supervisors

  {
    path: "/manage-supervisors",
    name: "Manage Supervisors",
    component: () => import("../views/Company/Supervisor/index.vue"),
    isMajor: true,
  },

  {
    path: "/trucks-mapped",
    name: "Trucks Mapped",
    component: () => import("../views/Company/Supervisor/trucksMapped.vue"),
    isMajor: true,
  },

  {
    path: "/manage-roles",
    name: "Roles",
    component: () => import("../views/Company/UsersManagement/Roles.vue"),
    isMajor: true,
  },
  {
    path: "/manage-clusters",
    name: "Manage Cluster",
    component: () => import("../views/Company/Clusters/Index.vue"),
    isMajor: true,
  },
  {
    path: "/manage-modules",
    name: "Manage Modules",
    component: () => import("../views/Company/UsersManagement/Modules.vue"),
    isMajor: true,
  },
  {
    path: "/manage-users",
    name: "Users",
    component: () => import("../views/Company/UsersManagement/Users.vue"),
    isMajor: true,
  },
  {
    path: "/cluster-locations",
    name: "Cluster Locations",
    component: () => import("../views/Company/Clusters/Trucks.vue"),
    isMajor: true,
  },

  {
    path: "/cluster-trucks",
    name: "Cluster Truck",
    component: () => import("../views/Company/Clusters/Trucks.vue"),
    isMajor: true,
  },

  {
    path: "/cluster-details",
    name: "Cluster Details",
    component: () => import("../views/Company/Clusters/Details.vue"),
    isMajor: true,
  },

  {
    path: "/schedule-details",
    name: "Schedule Details",
    component: () =>
      import("../views/Company/ManagePeddling/ScheduleDetails.vue"),
    isMajor: true,
  },

  // Settings

  {
    path: "/tracking-integration",
    name: "Tracking Integration",
    component: () =>
      import("../views/Company/Settings/TrackingIntegration.vue"),
    isMajor: true,
  },

  {
    path: "/schedule-settings",
    name: "Schedule Settings",
    component: () => import("../views/Company/Settings/ScheduleSettings.vue"),
    isMajor: true,
  },

  {
    path: "/alarms",
    name: "Alarms",
    component: () => import("../views/Company/Settings/Alarms.vue"),
    isMajor: true,
  },

  //customer routes
  {
    path: "/IHSAdmin/Dashboard",
    name: "Admin Dashboard",
    component: () => import("../views/Customer/IHSAdminDashboard.vue"),
    isMajor: true,
    meta: {
      authorize: true,
      authRoles: ["IHSAdmin"],
    },
  },
  {
    path: "/deliveryReport",
    name: "Delivery Report",
    component: () => import("../views/Customer/DeliveryReport.vue"),
    isMajor: true,
    meta: {
      authorize: true,
      authRoles: ["IHSAdmin"],
    },
  },
  {
    path: "/IHS/Dashboard",
    name: "User Dashboard",
    component: () => import("../views/Customer/IHSUserDashboard.vue"),
    isMajor: true,
    meta: {
      authorize: true,
      authRoles: ["IHS"],
    },
  },
  {
    path: "/Orders",
    name: "Orders",
    component: () => import("../views/Customer/Orders.vue"),
    isMajor: true,
    meta: {
      authorize: true,
      authRoles: ["IHSAdmin"],
    },
  },
  {
    path: "/Upload-History",
    name: "Upload History",
    component: () => import("../views/Customer/Upload-History.vue"),
    isMajor: true,
    meta: {
      authorize: true,
      authRoles: ["IHSAdmin"],
    },
  },
  {
    path: "/Upload-Details",
    name: "Upload History-Details",
    component: () => import("../views/Customer/Upload-Details.vue"),
    isMajor: true,
    meta: {
      authorize: true,
      authRoles: ["IHSAdmin"],
    },
  },
  {
    path: "/Upload-History",
    name: "Upload History",
    component: () =>
      import("../views/Company/ManagePeddling/UploadHistory.vue"),
    isMajor: true,
    meta: {
      authorize: true,
      authRoles: ["Company", "CompanyAdmin"],
    },
  },
  {
    path: "/Upload-Details",
    name: "Upload History-Details",
    component: () =>
      import("../views/Company/ManagePeddling/Upload-Details.vue"),
    isMajor: true,
    meta: {
      authorize: true,
      authRoles: ["Company", "CompanyAdmin"],
    },
  },
  {
    path: "/IHS-Primary-Trucks",
    name: "IHS Primary Trucks",
    component: () => import("../views/Customer/Reports/PrimaryTrucks"),
    isMajor: true,
  },
  {
    path: "/IHS-PrimaryRdcVariance",
    name: "IHS Primary-RDC variance report",
    component: () =>
      import("../views/Customer/Reports/PrimaryVarianceReportRDC.vue"),
    isMajor: true,
  },
  {
    path: "/IHS-SecondaryVolumeVariance",
    name: "IHS RDC-secondary volume variance",
    component: () =>
      import("../views/Customer/Reports/secondaryVolumeVariance.vue"),
    isMajor: true,
  },
  {
    path: "/IHS-Primary-tankFills",
    name: "IHS Primary Tank Fills",
    component: () => import("../views/Customer/Reports/PrimaryTankFills.vue"),
    isMajor: true,
  },
  {
    path: "/TotalRDCs-IHS",
    name: "IHS RDCS",
    component: () => import("../views/Customer/Reports/TotalRDCs.vue"),
  },
  {
    path: "/IHS-Deliveries",
    name: "IHS Deliveries",
    component: () => import("../views/Customer/Reports/Deliveries"),
    isMajor: true,
  },

  //journey officer
  {
    path: "/JourneyOfficer",
    name: "Manage Journey Officer",
    component: () => import("../views/JourneyOfficer/ManageJourneyOfficer.vue"),
    isMajor: true,
  },
  {
    path: "/mappedTrucks",
    name: "Mapped Trucks",
    component: () => import("../views/JourneyOfficer/MappedTrucks.vue"),
    isMajor: true,
  },
  {
    path: "/officerActivities",
    name: "Journey Officer Activities",
    component: () => import("../views/JourneyOfficer/officerActivities.vue"),
    isMajor: true,
  },

  //field officer
  {
    path: "/fieldOfficer",
    name: "Manage Field Officer",
    component: () => import("../views/FieldOfficer/manageFO.vue"),
    isMajor: true,
  },

  //locations management
  {
    path: "/locationManagement",
    name: "Location Management",
    component: () => import("../views/LocationManagement/index.vue"),
    isMajor: true,
  },

  //FSE OFFICER
  {
    path: "/FLogin",
    name: "FSE Login",
    component: () => import("../views/FSE/FSELogin.vue"),
    isMajor: true,
  },
  {
    path: "/DeliveryAcceptance",
    name: "Delivery Acceptance",
    component: () => import("../views/FSE/FSeDeliveryacceptance.vue"),
    isMajor: true,
  },

  // Viewer routes
  {
    path: "/Viewer/Dashboard",
    name: "Viewer Dashboard",
    component: () => import("../views/Viewer/Dashboard/index.vue"),
    isMajor: true,
    meta: {
      authorize: true,
      authRoles: ["TeamLead"],
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = `A&C :: ${to?.name}` ?? "A&C";

  const isAuthenticated = localStorage.getItem("user-details");

  if (to.name === "Login" && isAuthenticated) {
    next({ name: "Dashboard" }); // Replace 'Dashboard' with your desired route
  } else {
    next(); // Allow navigation for other routes
  }
});

export default router;
